<div nz-row class="query-metadata-wrapper" [nzGutter]="[16, 16]">
  <div nz-col nzSpan="6">
    <div class="nfl-form-label">Query Id</div>
    <span>{{ queryRecord.queryId }}</span>
  </div>
  <div nz-col nzSpan="5">
    <div class="nfl-form-label">Query Name</div>
    <span>{{ queryRecord.name }}</span>
  </div>
  <div nz-col nzSpan="6">
    <div class="nfl-form-label">Query Description</div>
    <span>{{ queryRecord.description }}</span>
  </div>
  <div nz-col nzSpan="4">
    <div class="nfl-form-label">Query Type</div>
    <span>{{ queryRecord.type }}</span>
  </div>

  <div nz-col nzSpan="3">
    <button nz-button nz-dropdown [nzDropdownMenu]="actionMenu" disabled>
      Action(s)
      <span nz-icon class="no-data-icon" nzType="down" nzTheme="outline"></span>
    </button>
  </div>
</div>
<nz-divider></nz-divider>

<div nz-row [nzGutter]="[16, 16]">
  <div nz-col nzSpan="6">
    <div class="nfl-form-label">File Size</div>
    <span nz-typography>{{ metaData.fileSize | fileSize }}</span>
  </div>
  <div nz-col nzSpan="5">
    <div class="nfl-form-label">Total Records</div>
    <span nz-typography>{{ metaData.totalRecords | number }}</span>
  </div>
  <div nz-col nzSpan="7">
    <div class="nfl-form-label">Audience Attributes</div>
    <p
      nz-typography
      nzEllipsis
      nzExpandable
      nzEllipsisRows="3"
      [nz-tooltip]="metaData.attributes"
      [nzContent]="metaData.attributes"
    ></p>
  </div>
</div>

<nz-dropdown-menu #actionMenu="nzDropdownMenu"> </nz-dropdown-menu>
